import { render, staticRenderFns } from "./StationsLayout.vue?vue&type=template&id=97cc3010&scoped=true&"
import script from "./StationsLayout.vue?vue&type=script&lang=js&"
export * from "./StationsLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97cc3010",
  null
  
)

export default component.exports